import React from 'react';

export const EMAIL_WATCHER_NOTIFICATION_INFO = (
    <span>
        Enable to receive email notifications about status changes in watched
        Change Requests and approved changes to Event Codes you are watching.
    </span>
);

export const EVENT_UPDATE_SUBSCRIPTION_INFO = (
    <span>
        Enable to receive daily email updates about newly created and
        updated Event Codes — based on your selected Event Sources and Families.
    </span>
);

export const EMAIL_REVIEWER_NOTIFICATION_INFO = (
    <span>Enable to receive Email notifications when change
        requests are ready for initial review.
    </span>
);

export const EMAIL_APPROVER_NOTIFICATION_INFO = (
    <span>Enable to receive Email notifications when change
        requests are ready for final review.
    </span>
);

export const SLACK_REVIEWER_NOTIFICATION_INFO = (
    <span>Enable to receive Slack notifications when change
        requests are ready for initial review.
    </span>
);

export const SLACK_APPROVER_NOTIFICATION_INFO = (
    <span>Enable to receive Slack notifications when change
        requests are ready for final review.
    </span>
);
